let itemElement = {
  resetContador: function (context) {
    jQuery(".milista-element", context).data("contador", 0);
    jQuery(".milista-element .badge-center", context).remove();
  },
  setContadorFromChild: function (obj) {
    const numero_de_repeticiones =
      $(obj).closest(".milista-element").data("contador") ?? 0;
    $(obj)
      .closest(".milista-element")
      .data("contador", numero_de_repeticiones + 1);
    this.drawContador($(obj).closest(".milista-element"));
  },
  setContador: function (obj, contador) {
    jQuery(obj).data("contador", contador);

    if (contador <= 0) {
      jQuery(obj).removeClass("highlight");
    } else {
      jQuery(obj).addClass("highlight");
    }
  },
  drawContador: function (elementIterable) {
    jQuery(elementIterable).find(".badge-center").remove();
    let contador = $(elementIterable).data("contador") ?? 0;
    if (contador > 0) {
      jQuery(elementIterable).append(
        '<span class="badge-center position-absolute top-0 start-0 translate-middle badge rounded-pill  ">' +
          +parseInt(contador) +
          "</span>"
      );
    }
  },
  execMinus: function (obj) {
    let _count = jQuery(obj).data("contador");

    let _new_count = _count - 1;

    if (_new_count < 0) {
      _new_count = 0;
    }

    this.setContador(obj, _new_count);
    this.drawContador(obj);
    $("#sound2")[0].currentTime = 0;
    $("#sound2")[0].play();
    /*
    if (_new_count <= 0) {
      jQuery(obj).removeClass(_self.classActive);
      jQuery(obj).find("span").addClass(_self.hiddenClass).text(_new_count);
    } else {
      jQuery(obj).addClass(_self.classActive);
      jQuery(obj).find("span").removeClass(_self.hiddenClass).text(_new_count);
    }
    */
  },
  updateListAfterClick: function (obj) {
    let elementoNuevo = jQuery(obj).find(".number").text().trim();
    let selectionArrayItems = [];
    let contador = jQuery(obj).data("contador");

    if (jQuery(obj).closest(".mylist").hasClass("listItemsA")) {
      addElementListAChanges(elementoNuevo, contador);
      selectionArrayItems = selectionListA;
    } else {
      addElementListBChanges(elementoNuevo, contador);
      selectionArrayItems = selectionListB;
    }

    let selectionStringItems = selectionArrayItems.join(",");
    jQuery(obj)
      .closest(".mylist")
      .find("input.input-filter-list")
      .val(selectionStringItems)
      .trigger("keyup");
  },
  updateListIds:function(context,listIds){
    jQuery("input.listIds", context).val(listIds);
  },
};
